import { render } from "./page-header.vue?vue&type=template&id=012f3f06&ts=true"
import script from "./page-header.ts?vue&type=script&lang=ts"
export * from "./page-header.ts?vue&type=script&lang=ts"

import "./page-header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__